class FjHeader {
  constructor() {
    this.menuButtons = document.querySelectorAll(
      '.fj-header__menu-button'
    );

    if (!this.menuButtons.length) return;

    this.bindEvents();
  }

  bindEvents() {
    this.menuButtons.forEach(button => {
      button.addEventListener('click', event => {
        event.stopPropagation();

        const menuItem = button.closest(
          '.fj-header__menu-item'
        );

        const isOpen =
          menuItem.classList.contains('is-open');

        this.closeMenus();

        if (!isOpen) {
          menuItem.classList.add('is-open');
        }
      });
    });

    document.addEventListener('click', () => {
      this.closeMenus();
    });
  }

  closeMenus() {
    document
      .querySelectorAll('.fj-header__menu-item.is-open')
      .forEach(item => {
        item.classList.remove('is-open');
      });
  }
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    new FjHeader();
  }
);